import { apiClient } from "../../../services/axiosInstance";
import { ServerResponse, Account } from "../../../types";

export type ProfilePayload = {
  name?: string;
  full_name?: string;
  description?: string;
  country_id?: string;
  ui_lang?: string;
  releases_lang?: string | null;
  display_real_name_in_public?: boolean;
  display_donations_in_public?: boolean;
  enable_pms?: boolean;
  hide_ai_results?: boolean;
  show_mature_content?: boolean;
  beta_access?: boolean;
};

export function postUpdateProfile(payload: ProfilePayload) {
  return apiClient.post<ServerResponse<Account>>("/v1/account/profile", {
    meta: [],
    payload,
  });
}
